
// src/pages/Courses/Courses.jsx

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import "./Courses.css";

import { getCourses } from "../../Components/Lib/contentful";
// import { getCourses } from "../../lib/contentful"; // adjust path if needed

export default function Courses() {

  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    async function loadCourses() {
      try {
        const data = await getCourses()
        setCourses(data)
      } catch (err) {
        console.error("Failed to load courses", err)
      } finally {
        setLoading(false)
      }
    }

    loadCourses()

  }, [])

  return (
    <div className="courses-page">

      {/* Hero */}
      <section className="courses-hero">
        <div className="container">
          <h1>DevLearn Capacity Building & Professional Development</h1>
          <p>
            Explore our 2026 portfolio of high-quality short courses designed to strengthen technical, analytical,
            and professional skills across development, research, governance, and private sectors.
          </p>

          <a
            href="https://forms.gle/MQrW26EzTQVGNCxY9"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-apply-hero"
          >
            Apply Now <ArrowRight size={20} />
          </a>
        </div>
      </section>


      {/* Courses Section */}
      <section className="courses-section">
        <div className="container">

          <div className="section-header">
            <h2>Our 2026 Short Courses</h2>
            <p>
              Practical, hands-on training designed for development professionals,
              researchers, students and organizations.
            </p>
          </div>


          {/* Loader */}
          {loading && (
            <div className="courses-loading">
              Loading courses...
            </div>
          )}


          {/* Courses Grid */}
          {!loading && (
            <div className="courses-grid">

              {courses.map((course) => (

                <article key={course.slug} className="course-card">

                  <div className="course-content">

                    <h3 className="course-title">{course.title}</h3>

                    <p className="course-overview">
                      {course.overview}
                    </p>

                    <div className="course-meta">

                      <span className="meta-item duration">
                        {course.duration}
                      </span>

                      <span className="meta-item fee">
                        ZMW {course.fee?.replace("ZMW ", "")}
                      </span>

                      <span className="meta-item modes">
                        {course.modes?.split(",")[0]}
                      </span>

                    </div>

                  </div>

                  <div className="course-footer">

                    <Link
                      to={`/courses/${course.slug}`}
                      className="btn-view-details"
                    >
                      View Details <ArrowRight size={16} />
                    </Link>

                    <a
                      href="https://forms.gle/MQrW26EzTQVGNCxY9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-apply-small"
                    >
                      Apply
                    </a>

                  </div>

                </article>

              ))}

            </div>
          )}


          {/* Bottom CTA */}
          <div className="bottom-cta">
            <p>Ready to take the next step in your professional development?</p>

            <a
              href="https://forms.gle/MQrW26EzTQVGNCxY9"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-apply-main"
            >
              Apply Now
            </a>
          </div>

        </div>
      </section>


      {/* Footer */}
      <footer className="footer">
        <div className="footer-grid">

          <div>
            <div className="footer-logo">DevLearn Impact Research Ltd</div>
            <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
            <p>+260 973 902 981 / +260 978 341 825</p>
            <p>info@devlearnimpact.com</p>
          </div>

          <div>
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Applied Research</a></li>
              <li><a href="/services">MERL Frameworks</a></li>
              <li><a href="/services">Capacity Building</a></li>
            </ul>
          </div>

          <div>
            <h4>Thematic Areas</h4>
            <ul>
              <li><a href="/sectors">Education & Health</a></li>
              <li><a href="/sectors">Governance & Climate</a></li>
              <li><a href="/sectors">Economic Inclusion</a></li>
            </ul>
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/team">Team</a></li>
              <li><a href="/case-studies">Projects</a></li>
            </ul>
          </div>

          <div>
            <h4>Connect</h4>
            <ul>
              <li>
                <a href="https://www.linkedin.com/company/devlearn-impact-research/">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/share/1AS3Ahfsy7/">
                  Facebook
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="copyright">
          © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
        </div>
      </footer>

    </div>
  )
}


// // src/pages/Courses/Courses.jsx
// import { Link } from 'react-router-dom';
// import { ArrowRight } from 'lucide-react';

// import './Courses.css';
// import { coursesData } from '../../Data/courses';

// export default function Courses() {
//   return (
//     <div className="courses-page">

//       {/* Hero */}
//       <section className="courses-hero">
//         <div className="container">
//           <h1>DevLearn Capacity Building & Professional Development</h1>
//           <p>
//             Explore our 2026 portfolio of high-quality short courses designed to strengthen technical, analytical, 
//             and professional skills across development, research, governance, and private sectors.
//           </p>
//           <a
//             href="https://forms.gle/MQrW26EzTQVGNCxY9"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="btn-apply-hero"
//           >
//             Apply Now <ArrowRight size={20} />
//           </a>
//         </div>
//       </section>

//       {/* Courses Section */}
//       <section className="courses-section">
//         <div className="container">
//           <div className="section-header">
//             <h2>Our 2026 Short Courses</h2>
//             <p>Practical, hands-on training designed for development professionals, researchers, students and organizations.</p>
//           </div>

//           <div className="courses-grid">
//             {coursesData.map((course) => (
//               <article key={course.slug} className="course-card">
//                 <div className="course-content">
//                   <h3 className="course-title">{course.title}</h3>
//                   <p className="course-overview">{course.overview}</p>

//                   <div className="course-meta">
//                     <span className="meta-item duration">{course.duration}</span>
//                     <span className="meta-item fee">ZMW {course.fee.replace('ZMW ', '')}</span>
//                     <span className="meta-item modes">{course.modes.split(',')[0]}</span>
//                   </div>
//                 </div>

//                 <div className="course-footer">
//                   <Link to={`/courses/${course.slug}`} className="btn-view-details">
//                     View Details <ArrowRight size={16} />
//                   </Link>
//                   <a
//                     href="https://forms.gle/MQrW26EzTQVGNCxY9"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="btn-apply-small"
//                   >
//                     Apply
//                   </a>
//                 </div>
//               </article>
//             ))}
//           </div>

//           <div className="bottom-cta">
//             <p>Ready to take the next step in your professional development?</p>
//             <a
//               href="https://forms.gle/MQrW26EzTQVGNCxY9"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn-apply-main"
//             >
//               Apply Now
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Footer - keep your existing footer or simplify */}
     
//       {/* Footer */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
//         </div>
//       </footer>
//     </div>
//   );
// }
// // src/pages/Courses/Courses.jsx
// import { Link } from 'react-router-dom';
// import { ArrowRight } from 'lucide-react';
// //import { coursesData } from '../../data/courses';

// //coursesData
// import './Courses.css';
// import { coursesData } from '../../Data/courses';

// export default function Courses() {

//   // src/data/courses.js    ← move data outside the component
 

//   return (
//     <div className="courses-page">
//       {/* Hero remains the same */}

//       <section className="courses-grid">
//         {coursesData.map((course) => (
//           <div key={course.id} className="course-card">
//             <div className="course-header">
//               <h3>{course.title}</h3>
//             </div>
//             <p className="course-overview">{course.overview}</p>

//             <div className="course-meta">
//               <div>Duration: <strong>{course.duration}</strong></div>
//               <div>Fee: <strong>{course.fee}</strong></div>
//               <div>Student Rate: <strong>{course.studentFee}</strong></div>
//             </div>

//             <div className="course-actions">
//               <Link to={`/courses/${course.slug}`} className="btn-view">
//                 View Details <ArrowRight size={16} />
//               </Link>
//               <a
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn-apply"
//               >
//                 Apply Now
//               </a>
//             </div>
//           </div>
//         ))}
//       </section>

//       {/* Footer remains */}
//     </div>
//   );
// }

// // src/Pages/Courses/Courses.jsx
// import { useState } from 'react';
// import { ArrowRight } from 'lucide-react';
// import '../../index.css';
// import './Courses.css';

// export const coursesData = [
//   {
//     id: "capacity-building-research-evaluation",
//     slug: "capacity-building-research-evaluation",
//     title: "Capacity Building in Research & Evaluation",
//     overview: "Strengthen technical, analytical, and professional skills...",
//     duration: "2 Weeks",
//     fee: "ZMW 2,000",
//     studentFee: "ZMW 1,500",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     requirements: "No prior experience required. Basic computer literacy recommended.",
//     targetAudience: "Development practitioners, researchers, M&E officers, policy analysts, university students",
//     learningOutcomes: [
//       "Design and implement effective capacity building interventions",
//       "Apply modern MERL frameworks in real-world projects",
//       "Use data analytics to support evidence-based decision making",
//       "Promote institutional learning and adaptive management"
//     ],
//     modules: [ /* ... same as before */ ],
//     convener: "Brian Mumba",
//     about: "Core pillar of DevLearn’s work...",
//   },
//   // ... other courses with their own slug/id
// ];

// const coursesData2 = [
//   {
//     title: "Capacity Building in Research & Evaluation",
//     overview: "Strengthen technical, analytical, and professional skills across development, research, governance, and private sectors.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,000",
//     studentFee: "ZMW 1,500",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Module 1: Principles of Capacity Building",
//       "Module 2: Applied Research & MERL Techniques",
//       "Module 3: Data Analytics and Policy Advisory",
//       "Module 4: Institutional Learning & Sustainability"
//     ],
//     convener: "Brian Mumba",
//     about: "Core pillar of DevLearn’s work to ensure learning is hands-on and responsive to real-world challenges.",
//   },
//   {
//     title: "Designing Questionnaires & Digital Data Collection using KoboToolbox",
//     overview: "Learn to design effective questionnaires and deploy them using KoboToolbox for field data collection.",
//     duration: "2 Weeks (5 Training Days)",
//     fee: "ZMW 2,000",
//     studentFee: "ZMW 1,500",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Introduction to Questionnaire Design Principles",
//       "Understanding Variables, Indicators, and Question Types",
//       "Developing Logical Flows and Skip Patterns",
//       "Introduction to KoboToolbox Interface",
//       "Building and Testing Forms in KoboToolbox",
//       "Deploying and Managing Field Data Collection",
//       "Exporting and Cleaning Data for Analysis",
//       "Data Quality Assurance and Ethical Considerations",
//       "Group Project – Design and Deploy a Real Survey Tool"
//     ],
//     convener: "Brian Mumba",
//     about: "Equip participants with skills needed for designing questionnaires, programming, and managing field data collection.",
//   },
//   {
//     title: "Introduction to Basic Microsoft Excel for Data Management and Analysis",
//     overview: "Build foundational Excel skills for data entry, management, analysis, and reporting.",
//     duration: "1 Week / 3 Days",
//     fee: "ZMW 1,500",
//     studentFee: "ZMW 1,200",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Introduction to Microsoft Excel",
//       "Data Entry and Formatting",
//       "Basic Formulas and Functions",
//       "Data Organisation and Cleaning",
//       "Tables and Simple Analysis",
//       "Charts and Data Visualisation",
//       "Printing and Sharing Excel Files",
//       "Practical Exercises and Mini Task"
//     ],
//     convener: "Richard Mwale",
//     about: "Practical, hands-on approach for beginners to gain confidence working with spreadsheets and basic data analysis.",
//   },
//   {
//     title: "Practical Python Programming for Data Analysis",
//     overview: "Learn Python programming and apply it to automate tasks and perform basic data analysis.",
//     duration: "2 Weeks (7 Training Days)",
//     fee: "ZMW 2,500",
//     studentFee: "ZMW 1,800",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Introduction to Python Programming",
//       "Basic Syntax and Data Types",
//       "Control Structures",
//       "Functions and Modules",
//       "Data Structures",
//       "File Handling",
//       "Introduction to Data Analysis with Python",
//       "Debugging and Good Programming Practice",
//       "Applied Exercises and Mini Project"
//     ],
//     convener: "Richard Mwale",
//     about: "Hands-on Python training focusing on practical exercises and real-world applications for beginners.",
//   },
//   {
//     title: "Introduction to Data Analysis in STATA",
//     overview: "Hands-on training in STATA for quantitative data analysis, data cleaning, coding, and reporting.",
//     duration: "2 Weeks (5 Training Days)",
//     fee: "ZMW 2,500",
//     studentFee: "ZMW 1,800",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Introduction to STATA Environment & Data Management",
//       "Importing and Cleaning Datasets",
//       "Variable Creation, Labelling, and Coding",
//       "Descriptive Statistics and Data Exploration",
//       "Hypothesis Testing and Inferential Analysis",
//       "Introduction to Regression Models",
//       "Data Visualisation and Reporting in STATA",
//       "Using Do-files and Reproducible Research Practices",
//       "Practical Exercises Using Development Data",
//       "Course Project and Peer Review"
//     ],
//     convener: "Brian Mumba",
//     about: "For beginners and intermediate users, emphasizes practical exercises with real datasets.",
//   },
//   {
//     title: "Legal Research and Writing",
//     overview: "Develop skills to conduct effective legal research, interpret citations, and communicate results clearly.",
//     duration: "2 Weeks (5 Training Days)",
//     fee: "ZMW 2,500",
//     studentFee: "ZMW 1,800",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "General overview of research",
//       "Introduction to legal research",
//       "Fundamentals of legal research",
//       "Types and methods of legal research",
//       "Legal research methodologies and scope",
//       "Data collection and analysis",
//       "Advanced legal research techniques and reporting",
//       "Framing issues in research proposal and dissertation",
//       "Practical application and writing",
//       "Relevant statutes and rules of statutory interpretation"
//     ],
//     convener: "Ms Tracy M Mbandama",
//     about: "Learn to identify, use, and analyze primary and secondary legal authorities to solve legal problems.",
//   },
//   {
//     title: "Human Rights Advocacy and Activism",
//     overview: "Understand human rights concepts and principles, develop advocacy skills, and engage in practical activism.",
//     duration: "2 Weeks (5 Training Days)",
//     fee: "ZMW 2,500",
//     studentFee: "ZMW 1,800",
//     modes: "Online, In-person, Blended",
//     certificate: "Certificate of Participation",
//     modules: [
//       "Introduction to human rights and advocacy",
//       "Understanding human rights frameworks",
//       "Advocacy strategies and tools",
//       "Research and evidence based advocacy",
//       "Communication skills for advocacy",
//       "Mobilizing communities and building alliances",
//       "Legal frameworks and advocacy",
//       "Human rights in conflict situations",
//       "National and global movements and their impact",
//       "Current and future trends in human rights and advocacy"
//     ],
//     convener: "Ms Tracy M Mbandama",
//     about: "Explore theoretical knowledge and practical skills for human rights advocacy and activism.",
//   },
// ];

// const Courses = () => {
//   const [selectedCourse, setSelectedCourse] = useState(null);

//   return (
//     <div className="courses-page">
//       {/* Hero */}
//       <section className="courses-hero">
//         <h1>DevLearn Capacity Building & Professional Development</h1>
//         <p>
//           Explore our 2026 portfolio of high-quality short courses designed to strengthen technical, analytical, and professional skills across development, research, governance, and private sectors.
//         </p>
//         <a
//           href="https://forms.gle/MQrW26EzTQVGNCxY9"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="btn-apply-hero"
//         >
//           Apply Now <ArrowRight size={20} />
//         </a>
//       </section>

//       {/* Courses Grid */}
//       <section className="courses-grid">
//         {coursesData.map((course, idx) => (
//           <div key={idx} className="course-card">
//             <div className="course-header">
//               <h3>{course.title}</h3>
//             </div>
//             <p className="course-overview">{course.overview}</p>
//             <div className="course-info">
//               <span>Duration: {course.duration}</span>
//               <span>Fee: {course.fee}</span>
//               <span>Student/CSO Rate: {course.studentFee}</span>
//               <span>Modes: {course.modes}</span>
//               <span>Certificate: {course.certificate}</span>
//             </div>
//             <div className="course-actions">
//               <button className="btn-view" onClick={() => setSelectedCourse(course)}>
//                 View Details <ArrowRight size={16} />
//               </button>
//               <a
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="btn-apply"
//               >
//                 Apply
//               </a>
//             </div>
//           </div>
//         ))}
//       </section>

//       {/* Modal for Course Details */}
//       {selectedCourse && (
//         <div className="modal-overlay" onClick={() => setSelectedCourse(null)}>
//           <div className="modal-content" onClick={e => e.stopPropagation()}>
//             <button className="btn-close" onClick={() => setSelectedCourse(null)}>Close</button>
//             <h2>{selectedCourse.title}</h2>
//             <p><strong>Overview:</strong> {selectedCourse.overview}</p>
//             <p><strong>Duration:</strong> {selectedCourse.duration}</p>
//             <p><strong>Fee:</strong> {selectedCourse.fee}</p>
//             <p><strong>Student/CSO Rate:</strong> {selectedCourse.studentFee}</p>
//             <p><strong>Modes of Learning:</strong> {selectedCourse.modes}</p>
//             <p><strong>Certificate:</strong> {selectedCourse.certificate}</p>
//             <p><strong>Course Convener:</strong> {selectedCourse.convener}</p>
//             <p><strong>About:</strong> {selectedCourse.about}</p>
//             <p><strong>Modules:</strong></p>
//             <ul>
//               {selectedCourse.modules.map((module, idx) => <li key={idx}>{module}</li>)}
//             </ul>
//             <a
//               href="https://forms.gle/MQrW26EzTQVGNCxY9"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn-apply"
//             >
//               Apply Now
//             </a>
//           </div>
//         </div>
//       )}

      // {/* Footer */}
      // <footer className="footer">
      //   <div className="footer-grid">
      //     <div>
      //       <div className="footer-logo">DevLearn Impact Research Ltd</div>
      //       <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
      //       <p>+260 973 902 981 / +260 978 341 825</p>
      //       <p>info@devlearnimpact.com</p>
      //     </div>
      //     <div>
      //       <h4>Services</h4>
      //       <ul>
      //         <li><a href="/services">Applied Research</a></li>
      //         <li><a href="/services">MERL Frameworks</a></li>
      //         <li><a href="/services">Capacity Building</a></li>
      //       </ul>
      //     </div>
      //     <div>
      //       <h4>Thematic Areas</h4>
      //       <ul>
      //         <li><a href="/sectors">Education & Health</a></li>
      //         <li><a href="/sectors">Governance & Climate</a></li>
      //         <li><a href="/sectors">Economic Inclusion</a></li>
      //       </ul>
      //     </div>
      //     <div>
      //       <h4>Company</h4>
      //       <ul>
      //         <li><a href="/about">About</a></li>
      //         <li><a href="/team">Team</a></li>
      //         <li><a href="/case-studies">Projects</a></li>
      //       </ul>
      //     </div>
      //     <div>
      //       <h4>Connect</h4>
      //       <ul>
      //         <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
      //         <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
      //       </ul>
      //     </div>
      //   </div>
      //   <div className="copyright">
      //     © 2025 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia, June 28, 2025.
      //   </div>
      // </footer>
//     </div>
//   );
// };

// export default Courses;

// // src/Pages/Courses/Courses.jsx
// import { useState } from 'react';
// import { ArrowRight } from 'lucide-react';
// import './Courses.css';

// const coursesData = [
//   {
//     title: "Capacity Building & Professional Development",
//     overview: "Strengthen technical, analytical, and professional skills through practical short courses grounded in applied research.",
//     duration: "Varies",
//     fee: "Varies",
//     delivery: "Online / In-person / Blended",
//     convener: "DevLearn Team",
//     modules: [
//       "Module 1: Introduction & Overview",
//       "Module 2: Applied Research & MERL Principles",
//       "Module 3: Digital Data Collection & Analysis",
//       "Module 4: Institutional Learning & Decision Support",
//     ],
//     priceDetails: {
//       standard: "Varies by course",
//       studentCSO: "Varies by course",
//       groupRate: "Negotiable for 5+ participants",
//     },
//     certification: "Certificate of Participation issued by DevLearn Impact Research Ltd",
//     details: "Capacity building is a core pillar of DevLearn Impact Research Ltd’s work. We design and deliver high-quality short courses that strengthen technical, analytical, and professional skills across the development, research, governance, and private sectors..."
//   },
//   {
//     title: "Designing Questionnaires & Digital Data Collection",
//     overview: "Learn to design robust questionnaires and deploy digital data collection using KoboToolbox.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,000",
//     delivery: "Online / In-person / Blended",
//     convener: "Brian Mumba",
//     modules: [
//       "Module 1: Introduction to Questionnaire Design Principles",
//       "Module 2: Understanding Variables, Indicators, and Question Types",
//       "Module 3: Developing Logical Flows and Skip Patterns",
//       "Module 4: Introduction to KoboToolbox Interface",
//       "Module 5: Building and Testing Forms in KoboToolbox",
//       "Module 6: Deploying and Managing Field Data Collection",
//       "Module 7: Exporting and Cleaning Data for Analysis",
//       "Module 8: Data Quality Assurance and Ethical Considerations",
//       "Module 9: Group Project – Design and Deploy a Real Survey Tool",
//     ],
//     priceDetails: {
//       standard: "ZMW 2,000",
//       studentCSO: "ZMW 1,500",
//       groupRate: "Negotiable for 5+ participants",
//     },
//     certification: "Certificate of Participation issued by DevLearn Impact Research Ltd",
//     details: "Accurate, well-structured questionnaires and efficient data collection processes are the backbone of any research, monitoring, or evaluation activity. This course equips participants with the technical and analytical skills needed to design effective questionnaires..."
//   },
//   {
//     title: "Introduction to Basic Microsoft Excel",
//     overview: "Build foundational Excel skills for data management, analysis, and reporting.",
//     duration: "1 Week",
//     fee: "ZMW 1,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Richard Mwale",
//     modules: [
//       "Module 1: Introduction to Microsoft Excel",
//       "Module 2: Data Entry and Formatting",
//       "Module 3: Basic Formulas and Functions",
//       "Module 4: Data Organisation and Cleaning",
//       "Module 5: Tables and Simple Analysis",
//       "Module 6: Charts and Data Visualisation",
//       "Module 7: Printing and Sharing Excel Files",
//       "Module 8: Practical Exercises and Mini Task",
//     ],
//     priceDetails: {
//       standard: "ZMW 1,500",
//       studentCSO: "ZMW 1,200",
//       groupRate: "Negotiable for 5+ participants",
//     },
//     certification: "Certificate of Participation issued by DevLearn Impact Research Ltd",
//     details: "Microsoft Excel is one of the most widely used tools for data entry, management, analysis, and reporting across business, government, academia, and development organisations. This short course introduces participants to the fundamental features of Microsoft Excel using a practical, hands-on approach..."
//   },
//   // Add other courses similarly...
// ];

// const Courses = () => {
//   const [selectedCourse, setSelectedCourse] = useState(null);

//   return (
//     <div className="courses-page">
//       {/* Hero Section with CTA for Capacity Building */}
//       <section className="courses-hero">
//         <div className="container">
//           <h1>Short Courses 2026</h1>
//           <p>
//             DevLearn Impact Research Ltd offers hands-on capacity building programs across research, data, governance, and advocacy. Explore our courses below or start your learning journey now.
//           </p>
//           <a
//             href="https://forms.gle/MQrW26EzTQVGNCxY9"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="btn btn-apply-hero"
//           >
//             Enroll in Capacity Building <ArrowRight size={18} />
//           </a>
//         </div>
//       </section>

//       {/* Courses Grid */}
//       <section className="courses-grid container">
//         {coursesData.map((course, idx) => (
//           <div key={idx} className="course-card">
//             <div className="course-header">
//               <h3>{course.title}</h3>
//             </div>
//             <p className="course-overview">{course.overview}</p>
//             <div className="course-info">
//               <span><strong>Duration:</strong> {course.duration}</span>
//               <span><strong>Fee:</strong> {course.fee}</span>
//               <span><strong>Delivery:</strong> {course.delivery}</span>
//               <span><strong>Convener:</strong> {course.convener}</span>
//             </div>
//             <div className="course-actions">
//               <button 
//                 className="btn btn-view"
//                 onClick={() => setSelectedCourse(course)}
//               >
//                 View Details <ArrowRight size={16} />
//               </button>
//               <a 
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9" 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 className="btn btn-apply"
//               >
//                 Apply Now
//               </a>
//             </div>
//           </div>
//         ))}
//       </section>

//       {/* Modal for full course details */}
//       {selectedCourse && (
//         <div className="modal-overlay" onClick={() => setSelectedCourse(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <h2>{selectedCourse.title}</h2>
//             <p><strong>Overview:</strong> {selectedCourse.details}</p>
//             <p><strong>Modules:</strong></p>
//             <ul>
//               {selectedCourse.modules.map((mod, idx) => <li key={idx}>{mod}</li>)}
//             </ul>
//             <p><strong>Fee:</strong> Standard: {selectedCourse.priceDetails.standard} | Student/CSO: {selectedCourse.priceDetails.studentCSO} | Group: {selectedCourse.priceDetails.groupRate}</p>
//             <p><strong>Delivery Modes:</strong> {selectedCourse.delivery}</p>
//             <p><strong>Certification:</strong> {selectedCourse.certification}</p>
//             <p><strong>Convener:</strong> {selectedCourse.convener}</p>
//             <a
//               href="https://forms.gle/MQrW26EzTQVGNCxY9"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn btn-apply"
//             >
//               Apply Now
//             </a>
//             <button className="btn btn-close" onClick={() => setSelectedCourse(null)}>Close</button>
//           </div>
//         </div>
//       )}

//       {/* Footer */}
//       <footer className="footer" style={{ background: '#111827', color: '#fff' }}>
//         <div className="footer-grid container">
//           <div>
//             <div className="footer-logo" style={{ color: '#F7941D' }}>DevLearn Impact Research Ltd</div>
//             <p>Plot No. 3788/A, Avondale Road, Lusaka</p>
//             <p>+260 973 902 981 / +260 978 341 825</p>
//             <p>info@devlearnimpact.com</p>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="/services">Applied Research</a></li>
//               <li><a href="/services">MERL Frameworks</a></li>
//               <li><a href="/services">Capacity Building</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Thematic Areas</h4>
//             <ul>
//               <li><a href="/sectors">Education & Health</a></li>
//               <li><a href="/sectors">Governance & Climate</a></li>
//               <li><a href="/sectors">Economic Inclusion</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="/about">About</a></li>
//               <li><a href="/team">Team</a></li>
//               <li><a href="/case-studies">Projects</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4>Connect</h4>
//             <ul>
//               <li><a href="https://www.linkedin.com/company/devlearn-impact-research/">LinkedIn</a></li>
//               <li><a href="https://www.facebook.com/share/1AS3Ahfsy7/">Facebook</a></li>
//             </ul>
//           </div>
//         </div>
//         <div className="copyright" style={{ color: '#9CA3AF', textAlign: 'center', padding: '20px 0' }}>
//           © 2026 DevLearn Impact Research Ltd. All rights reserved. Registered in Zambia.
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Courses;


// // src/Pages/Courses/Courses.jsx
// import { useState } from 'react';
// import { ArrowRight } from 'lucide-react';
// import './Courses.css'; // Page-specific styles

// const coursesData = [
//   {
//     title: "Designing Questionnaires & Digital Data Collection",
//     overview: "Learn to design robust questionnaires and deploy digital data collection using KoboToolbox.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,000",
//     delivery: "Online / In-person / Blended",
//     convener: "Brian Mumba",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
//   {
//     title: "Introduction to Basic Microsoft Excel",
//     overview: "Build foundational Excel skills for data management, analysis, and reporting.",
//     duration: "1 Week",
//     fee: "ZMW 1,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Richard Mwale",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
//   {
//     title: "Practical Python Programming for Data Analysis",
//     overview: "Hands-on Python for data analysis, automation, and real-world problem-solving.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Richard Mwale",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
//   {
//     title: "Introduction to Data Analysis in STATA",
//     overview: "Learn STATA for data cleaning, analysis, and visualization in development research.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Brian Mumba",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
//   {
//     title: "Legal Research and Writing",
//     overview: "Learn fundamental legal research principles and practical writing techniques.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Tracy M Mbandama",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
//   {
//     title: "Human Rights Advocacy and Activism",
//     overview: "Understand human rights principles, advocacy methods, and activism strategies.",
//     duration: "2 Weeks",
//     fee: "ZMW 2,500",
//     delivery: "Online / In-person / Blended",
//     convener: "Tracy M Mbandama",
//     details: "Full course details including modules, target group, learning outcomes, and evaluation...",
//   },
// ];

// const Courses = () => {
//   const [selectedCourse, setSelectedCourse] = useState(null);

//   return (
//     <div className="courses-page">
//       {/* Hero Section */}
//       <section className="courses-hero">
//         <div className="container">
//           <h1>Capacity Building & Professional Development</h1>
//           <p>
//             Explore DevLearn Impact Research Ltd's 2026 portfolio of short courses. Build practical skills in research, data, analysis, and advocacy.
//           </p>
//         </div>
//       </section>

//       {/* Courses Grid */}
//       <section className="courses-grid container">
//         {coursesData.map((course, idx) => (
//           <div key={idx} className="course-card">
//             <div className="course-header">
//               <h3>{course.title}</h3>
//             </div>
//             <p className="course-overview">{course.overview}</p>
//             <div className="course-info">
//               <span><strong>Duration:</strong> {course.duration}</span>
//               <span><strong>Fee:</strong> {course.fee}</span>
//               <span><strong>Delivery:</strong> {course.delivery}</span>
//               <span><strong>Convener:</strong> {course.convener}</span>
//             </div>
//             <div className="course-actions">
//               <button 
//                 className="btn btn-view"
//                 onClick={() => setSelectedCourse(course)}
//               >
//                 View Details <ArrowRight size={16} />
//               </button>
//               <a 
//                 href="https://forms.gle/MQrW26EzTQVGNCxY9" 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 className="btn btn-apply"
//               >
//                 Apply Now
//               </a>
//             </div>
//           </div>
//         ))}
//       </section>

//       {/* Modal for course details */}
//       {selectedCourse && (
//         <div className="modal-overlay" onClick={() => setSelectedCourse(null)}>
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <h2>{selectedCourse.title}</h2>
//             <p>{selectedCourse.details}</p>
//             <button className="btn btn-close" onClick={() => setSelectedCourse(null)}>
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Courses;

// // pages/Courses/Courses.jsx
// import { useState } from 'react';
// import { ArrowRight } from 'lucide-react';
// import '../../index.css';
// import './Courses.css';

// const Courses = () => {
//   const accentOrange = '#F7941D';
//   const accentYellow = '#FBB040';
//   const accentPink = '#BA477C';
//   const mainFont = "'Poppins', sans-serif";

//   const courses = [
//     {
//       title: 'DESIGNING QUESTIONNAIRES AND DIGITAL DATA COLLECTION USING KOBOTOOLBOX',
//       convener: 'Brian Mumba',
//       duration: '2 Weeks (Intensive)',
//       overview: `Accurate, well-structured questionnaires and efficient data collection processes...`,
//       modules: [
//         'Module 1: Introduction to Questionnaire Design Principles',
//         'Module 2: Understanding Variables, Indicators, and Question Types',
//         'Module 3: Developing Logical Flows and Skip Patterns',
//         'Module 4: Introduction to KoboToolbox Interface',
//         'Module 5: Building and Testing Forms in KoboToolbox',
//         'Module 6: Deploying and Managing Field Data Collection',
//         'Module 7: Exporting and Cleaning Data for Analysis',
//         'Module 8: Data Quality Assurance and Ethical Considerations',
//         'Module 9: Group Project – Design and Deploy a Real Survey Tool'
//       ],
//     },
//     {
//       title: 'INTRODUCTION TO BASIC MICROSOFT EXCEL FOR DATA MANAGEMENT AND ANALYSIS',
//       convener: 'Richard Mwale',
//       duration: '1 Week or 3 days (Intensive)',
//       overview: `Microsoft Excel is one of the most widely used tools for data entry, management, analysis...`,
//       modules: [
//         'Module 1: Introduction to Microsoft Excel',
//         'Module 2: Data Entry and Formatting',
//         'Module 3: Basic Formulas and Functions',
//         'Module 4: Data Organisation and Cleaning',
//         'Module 5: Tables and Simple Analysis',
//         'Module 6: Charts and Data Visualisation',
//         'Module 7: Printing and Sharing Excel Files',
//         'Module 8: Practical Exercises and Mini Task'
//       ],
//     },
//     {
//       title: 'PRACTICAL PYTHON PROGRAMMING FOR DATA ANALYSIS',
//       convener: 'Richard Mwale',
//       duration: '2 Weeks (Intensive)',
//       overview: `Python is one of the most widely used programming languages globally...`,
//       modules: [
//         'Module 1: Introduction to Python Programming',
//         'Module 2: Basic Syntax and Data Types',
//         'Module 3: Control Structures',
//         'Module 4: Functions and Modules',
//         'Module 5: Data Structures',
//         'Module 6: File Handling',
//         'Module 7: Introduction to Data Analysis with Python',
//         'Module 8: Debugging and Good Programming Practice',
//         'Module 9: Applied Exercises and Mini Project'
//       ],
//     },
//     {
//       title: 'INTRODUCTION TO DATA ANALYSIS IN STATA',
//       convener: 'Brian Mumba',
//       duration: '2 Weeks (Intensive)',
//       overview: `STATA is one of the most widely used statistical software packages for data management...`,
//       modules: [
//         'Module 1: Introduction to STATA Environment & Data Management',
//         'Module 2: Importing and Cleaning Datasets',
//         'Module 3: Variable Creation, Labelling, and Coding',
//         'Module 4: Descriptive Statistics and Data Exploration',
//         'Module 5: Hypothesis Testing and Inferential Analysis',
//         'Module 6: Introduction to Regression Models (OLS, Logistic)',
//         'Module 7: Data Visualisation and Reporting in STATA',
//         'Module 8: Using Do-files and Reproducible Research Practices',
//         'Module 9: Practical Exercises Using Development Data',
//         'Module 10: Course Project and Peer Review'
//       ],
//     },
//     {
//       title: 'LEGAL RESEARCH AND WRITING',
//       convener: 'Ms Tracy M Mbandama',
//       duration: '2 Weeks (Intensive)',
//       overview: `This course introduces students to the basic principles of legal research...`,
//       modules: [
//         'Module 1: General overview of research',
//         'Module 2: Introduction to legal research and its role',
//         'Module 3: Fundamentals of legal research',
//         'Module 4: Types and methods of legal research',
//         'Module 5: Legal research methodologies and scope',
//         'Module 6: Data collection and analysis in legal research',
//         'Module 7: Advanced legal research techniques and reporting',
//         'Module 8: Framing issues in legal research proposal and dissertation',
//         'Module 9: Practical application and writing',
//         'Module 10: Relevant statutes and rules of statutory interpretation'
//       ],
//     },
//     {
//       title: 'HUMAN RIGHTS ADVOCACY AND ACTIVISM',
//       convener: 'Ms Tracy M Mbandama',
//       duration: '2 Weeks (Intensive)',
//       overview: `Human rights advocacy and activism is a course tailored to create an understanding of human rights concepts...`,
//       modules: [
//         'Module 1: Introduction to human rights and advocacy',
//         'Module 2: Understanding human rights frameworks',
//         'Module 3: Advocacy strategies and tools',
//         'Module 4: Research and evidence-based advocacy',
//         'Module 5: Communication skills for advocacy',
//         'Module 6: Mobilizing communities and building alliances',
//         'Module 7: Legal frameworks and advocacy',
//         'Module 8: Human rights in conflict situations',
//         'Module 9: National and global movements and their impact',
//         'Module 10: Current and future trends in human rights and advocacy'
//       ],
//     },
//   ];

//   const [expandedCourse, setExpandedCourse] = useState(null);

//   const toggleCourse = (index) => setExpandedCourse(expandedCourse === index ? null : index);

//   return (
//     <div style={{ fontFamily: mainFont }}>
//       {/* Hero */}
//       <section className="hero" style={{ background: '#F0F9FF', padding: '60px 20px', textAlign: 'center' }}>
//         <h1 style={{ color: accentPink, fontWeight: 700, fontSize: '2.5rem' }}>Capacity Building and Professional Development</h1>
//         <p style={{ maxWidth: '800px', margin: '20px auto', fontWeight: 400 }}>
//           Capacity building is a core pillar of DevLearn Impact Research Ltd’s work. We design and deliver high-quality short courses that strengthen technical, analytical, and professional skills across the development, research, governance, and private sectors.
//         </p>
//         <a href="https://forms.gle/MQrW26EzTQVGNCxY9" target="_blank" rel="noopener noreferrer"
//           style={{ display: 'inline-block', marginTop: '30px', background: accentOrange, color: '#fff', padding: '14px 28px', fontWeight: 700, fontSize: '1rem', borderRadius: '8px', textDecoration: 'none' }}>
//           Enroll Now <ArrowRight size={20} />
//         </a>
//       </section>

//       {/* Courses List */}
//       <section className="section courses-list" style={{ padding: '40px 20px', background: '#fff' }}>
//         <div className="container" style={{ maxWidth: '1000px', margin: '0 auto' }}>
//           <h2 style={{ color: accentPink, fontWeight: 700, textAlign: 'center', marginBottom: '40px' }}>List of Short Courses 2026</h2>
//           {courses.map((course, idx) => (
//             <div key={idx} style={{ marginBottom: '30px', border: `2px solid ${accentOrange}`, borderRadius: '12px', padding: '20px' }}>
//               <div
//                 onClick={() => toggleCourse(idx)}
//                 style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//               >
//                 <h3 style={{ color: accentOrange, fontWeight: 700 }}>{course.title}</h3>
//                 <span style={{ color: accentPink, fontWeight: 700 }}>{expandedCourse === idx ? '-' : '+'}</span>
//               </div>
//               {expandedCourse === idx && (
//                 <div style={{ marginTop: '15px', fontWeight: 400 }}>
//                   <p><strong>Course Convener / Lead Facilitator:</strong> {course.convener}</p>
//                   <p><strong>Duration:</strong> {course.duration}</p>
//                   <p>{course.overview}</p>
//                   <ul>
//                     {course.modules.map((mod, i) => (
//                       <li key={i} style={{ marginBottom: '5px' }}>{mod}</li>
//                     ))}
//                   </ul>
//                   <a href="https://forms.gle/MQrW26EzTQVGNCxY9" target="_blank" rel="noopener noreferrer"
//                     style={{ display: 'inline-block', marginTop: '15px', background: accentOrange, color: '#fff', padding: '10px 22px', fontWeight: 600, borderRadius: '6px', textDecoration: 'none' }}>
//                     Enroll in this Course
//                   </a>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Courses;
